import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { CardBody, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';

const DetailInformationRegisterSMAModal = ({
	dataInformationRegisterSMA,
	isOpen,
	handleToggleModalDetail,
}) => {
	return (
		<Modal
			isOpen={isOpen}
			toggle={handleToggleModalDetail}
			size='lg'
			className='border-0'
			modalClassName='modal fade zoomIn'
			backdrop={'static'}
			centered={true}
		>
			<ModalHeader toggle={handleToggleModalDetail}>
				Dispositivos
			</ModalHeader>
			<ModalBody className='modal-body'>
				{dataInformationRegisterSMA && dataInformationRegisterSMA.procesos ? (
					<table className="table">
						<thead>
							<tr>
								<th>Proceso ID</th>
								<th>Dispositivo ID</th>
								<th>Dispositivo ID Proveedor</th>
								<th>Parámetros</th>
							</tr>
						</thead>
						<tbody>
							{dataInformationRegisterSMA.procesos.map((proceso, procesoIndex) => (
								<tr key={procesoIndex}>
									<td>{proceso.procesoId}</td>
									<td>{proceso.dispositivoID}</td>
									<td>{proceso.info}</td>
									<td>
										<ul className='m-0'>
											{proceso.parameters.map((param, paramIndex) => (
												<li key={paramIndex}>
													{param.variable}: {param.unit}
												</li>
											))}
										</ul>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<p>No hay datos disponibles</p>
				)}
			</ModalBody>
		</Modal>
	);
};

export default DetailInformationRegisterSMAModal;
